import { render, staticRenderFns } from "./PdfTableRow.vue?vue&type=template&id=2fd60cda&"
import script from "./PdfTableRow.vue?vue&type=script&lang=ts&"
export * from "./PdfTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports